module.exports = __webpack_public_path__ + "img/ANGEL SHADES PURPLE.f268e62.svg";